import styled from 'styled-components'

import { FloatingContainer } from '@avantstay/backoffice-core'
import {
  _M_Normal,
  Card,
  desktopMediaQuery,
  mainColors,
  rgba,
  Tab,
  tabletOrMobileMediaQuery,
  TabPanel,
  TabPanels,
} from '@avantstay/backoffice-core'
import { Tabs as _Tabs } from '@avantstay/backoffice-core'

import { EmptyMessage } from '@new/__global/components/EmptyMessage'

export const Tabs = styled(_Tabs)`
  height: unset;
  padding-bottom: 0;
`

export const Container = styled(Card)`
  width: 560px;
  margin-top: 26px;
  min-height: 120px;
  position: relative;
  right: -10px;
  border: 1px solid ${mainColors.neutralExtraLight};
  box-sizing: border-box;

  ${tabletOrMobileMediaQuery`
    margin-top: 18px;
    left: 0;
    width: 100vw;
  `}
`

export const MessageStyled = styled(EmptyMessage)`
  margin: 0;
  height: 120px;
  align-items: center;
  display: flex;
  justify-content: center;
`

export const FloatingContainerStyled = styled(FloatingContainer)`
  ${tabletOrMobileMediaQuery`
    top: 60px;
    left: 0 !important;
  `}
`

export const FloatingContainerMobileBackground = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 60px;
  left: 0;
  background-color: ${rgba(mainColors.primaryDark, 0.4)};
`

/* Instructions Component */

export const InstructionsMessage = styled(EmptyMessage)`
  margin: 0;
  display: flex;
  flex-direction: column;
  padding: 20px 0 0 24px;
  text-align: left;

  ${tabletOrMobileMediaQuery`
    padding: 20px 16px;
  `}
`

export const InstructionItem = styled.span`
  ${_M_Normal};
  color: ${mainColors.black};
  margin-bottom: 20px;
`

export const InstructionsContainer = styled.span`
  display: flex;
  align-items: center;
  margin: 3px 0;

  svg {
    color: ${mainColors.neutralDark};
    margin-right: 5px;
  }
`

export const Footer = styled.footer`
  ${_M_Normal};
  padding: 12px 24px;
  background: ${rgba(mainColors.accentExtremelyLight, 0.7)};
`

export const TabStyled = styled(Tab)<{ disabled?: boolean }>`
  &[data-reach-tab] {
    &:not(:last-child) {
      margin-left: 16px;
    }

    &:last-child {
      margin-left: 16px;
      margin-right: 16px;
    }
  }
`

export const TabLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TabPanelStyled = styled(TabPanel)`
  // important here to overwrite TabPanel padding
  padding: 0 0 20px !important;

  ${tabletOrMobileMediaQuery`
    padding: 0 !important;
  `}
`

export const TabPanelsStyled = styled(TabPanels)`
  max-height: 455px;
  overflow-y: auto;
  padding-top: 20px;

  ${tabletOrMobileMediaQuery`
    max-height: 300px;
  `}
`

/* Loading */

export const LoadingContainer = styled.div`
  padding: 40px 0;
`

export const Root = styled.div`
  display: block;
  background-color: ${rgba(mainColors.neutralExtremelyDark, 0.2)};
  height: 34px;
  border-radius: 2px;
  padding: 5px 10px;
  width: 100%;
  margin-left: 18px;

  ${desktopMediaQuery`
    max-width: 200px;
  `}
`
